import { formatDistanceToNow } from 'date-fns';

const ONE_MINUTE = 60_000;

export const createReadableDistanceString = (time: Date, options = {}) => {
  const current = new Date();
  const diff = current.getTime() - time.getTime();
  if (diff < ONE_MINUTE) {
    return '< 1m';
  }
  return formatDistanceToNow(time, options);
};
